import { TipoEstatisticaCarteira } from './enum';

export class CarteiraDeIntegradoresEstatisticasFiltro {
  tipoFiltroPeriodo: number;
  inicio: Date;
  fim: Date;
  idVendedor: number;
  tipoEstatistica: TipoEstatisticaCarteira;
  pesquisaPorTimes: boolean;
}
